import { useEffect, useContext } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import AOS from 'aos'
import access from 'src/utils/localAccess'
import 'aos/dist/aos.css'
import modules from 'src/app/app.module'
import preauthModules from 'src/app/preAuth/preauth.module'
import adminModules from 'src/app/auth/admin/admin.module'
import commonModules from 'src/app/auth/common/common.module'
import clientModules from 'src/app/auth/client/client.module'
import partnerModules from 'src/app/auth/partner/partner.module'
import publicClientModules from 'src/app/preAuth/@client/client.module'
import Signin from 'src/app/preAuth/signin'
import Dashboard from 'src/app/auth/admin/dashboard'
import MyProfile from 'src/app/auth/common/myProfile'
import Discover from 'src/app/auth/client/discover'
import Products from 'src/app/auth/partner/products'
import Public_Discover from 'src/app/preAuth/@client/discover'
import { StatusHandler } from 'src/component'

export const AppRoutes = () => {

    const {notifier, isConnected} = useContext(VisibilityContext)
    const {recoverStatesData} = useContext(AppInfoContext)

    useEffect(() => {
        AOS.init({
            duration: 300,
            delay: 20,
            easing: 'linear'
        })
    }, [])

    useEffect(() => {
        let isOnline = window.navigator.onLine
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
        recoverStatesData()
    }, [])

    useEffect(() => {
        window.addEventListener("offline", 
        () => handleInternetConnection(false)
      );
        window.addEventListener("online", 
        () => handleInternetConnection(true)
      );

      return () => {
        window.removeEventListener("offline", () => handleInternetConnection(false)
        );
        window.removeEventListener("online", () => handleInternetConnection(true));
      };
    }, [])

    function handleInternetConnection (isOnline: boolean) {
        if(!isOnline)  notifier.show('Oops...You are offline', '')
        else notifier.show('Network has been restored', '', 'success')
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
    }
    return (
        <>
            <StatusHandler />
            <Router>
                <Routes>
                    {
                        modules.map(module => (
                            module.name === 'Admin' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        adminModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={Dashboard.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/admin/dashboard" />}/>
                                </Route>
                            :
                            module.name === 'Common' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        commonModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={MyProfile.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/general/profile" />}/>
                                </Route>
                            :
                            module.name === 'Client' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        clientModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={Discover.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/client/discover" />}/>
                                </Route>
                            :
                            module.name === 'Partner' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        partnerModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={Products.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/partner/products" />}/>
                                </Route>
                            :
                            module.name === 'Public Client' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        publicClientModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={Public_Discover.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/public/client/discover" />}/>
                                </Route>
                            :
                            module.name === 'Preauth' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        preauthModules.map(module => (
                                            <Route {...module.routeProps} key={module.name}  />
                                        ))
                                    } 
                                    <Route index element={Signin.routeProps.element} />
                                    <Route path="*" element={<Navigate to="/" />}/>
                                </Route>  
                            :
                            <Route {...module.routeProps} key={module.name}  />
                        ))
                    }
                    <Route path="*" element={<Navigate to="/" />}/>
                </Routes>
            </Router>
        </>
    )
}